import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Beneficiary from './Beneficiary'
import Payer from './Payer'

import {
  useCampaignSetup,
  useCampaignSetupDispatch,
} from 'components/Recommendations/Campaign/Context/CampaignSetupContext'
import { fetchDsaRecommendations } from 'api/integrations'
import { getActivePlatformsForSetup } from 'domain/adPreview/fromSetup'
import { PlacementPlatform } from 'domain/adPreview/placementGroups'
import { AssetClass, Platform } from 'domain/integrationAssets/schemas'

export default function DsaFields({ disabled = false, bothSelected = false }) {
  const { setup } = useCampaignSetup()
  const { updateDsaFields } = useCampaignSetupDispatch()
  const [recommendations, setRecommendations] = useState(null)
  const platforms = getActivePlatformsForSetup(setup)
  const includesMeta = platforms.includes(PlacementPlatform.META)

  useEffect(() => {
    const loadDsaDefaults = async () => {
      // DSA recommendations are a Meta endpoint — a multi-platform setup also
      // carries a Google ad_account entry, which must never be sent here.
      if (!includesMeta) return

      const adAccountId =
        setup?.integration_details?.find(
          (x) => x.asset_class === AssetClass.ad_account && x.platform === Platform.facebook,
        )?.asset_id || null
      if (!adAccountId) return

      const response = await fetchDsaRecommendations(adAccountId)
      if (!response?.success) return

      const partnerDetails = JSON.parse(localStorage.getItem('partnerDetails') || '{}')
      const clientName = partnerDetails?.name || ''

      const beneficiary =
        response?.data?.dsa_recommendations?.[0] ||
        response?.data?.default_dsa_beneficiary ||
        clientName
      const payer =
        response?.data?.dsa_recommendations?.[0] || response?.data?.default_dsa_payor || clientName

      setRecommendations({
        beneficiary,
        payer,
      })

      // if setup doesn't have dsa_beneficiary or dsa_payor, update them with the recommendations.
      // Skip when disabled (no edit rights) - nothing should be persisted on their behalf.
      if (!disabled && (setup?.dsa_beneficiary === null || setup?.dsa_payor === null)) {
        updateDsaFields({
          ...(!setup?.dsa_beneficiary && beneficiary ? { dsa_beneficiary: beneficiary } : {}),
          ...(!setup?.dsa_payor && payer ? { dsa_payor: payer } : {}),
        })
      }
    }

    loadDsaDefaults()
  }, [disabled, includesMeta])

  if (!includesMeta) {
    return null
  }

  return (
    <div className="billing-info">
      <Beneficiary recommendation={recommendations?.beneficiary} disabled={disabled} bothSelected={bothSelected} />

      <Payer recommendation={recommendations?.payer} disabled={disabled} bothSelected={bothSelected} />
    </div>
  )
}

DsaFields.propTypes = {
  disabled: PropTypes.bool,
}
